// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"b1_c0","quote":"b1_dP","author":"b1_fl"};